export const getFormattedDate = (date: string) => {
    const separateDate = date.split(' ');
    return `${separateDate[0]} ${separateDate[1]}, ${separateDate[2]}`;
};
